export default __webpack_public_path__ + "static/media/WordWork_06.e1c66a75.png";